import styled from "styled-components";
import media from "styled-media-query";

export const Modal = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: var(--app-height);

  display: ${({ open }) => (open ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const ModalWrapper = styled.div`
  background-color: white;
  color: black;
  max-width: 624px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: auto;
  border-radius: 24px 24px 0 0;
  z-index: 1;
  overflow: hidden;
  position: absolute;
  bottom: 0;

  ${media.greaterThan("1260px")`
    border-radius: 24px;
    position: static;
`}
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 16px;
  padding: 32px;
  width: 100%;

  button {
    font-family: ${({ theme }) => theme.font.fontFamily};
    font-size: ${({ theme }) => theme.font.heading.xs};
    font-weight: ${({ theme }) => theme.font.weight.medium};
  }

  ${media.greaterThan("1260px")`
    flex-direction: row;
    justify-content: flex-end;
  `}
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${({ theme }) => theme.font.body.md};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  padding: 32px;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.neutral.white};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${({ theme }) => theme.font.heading.x};
  font-weight: ${({ theme }) => theme.font.weight.medium};
`;

export const Background = styled.div`
  color: white;
  position: fixed;
  height: var(--app-height);
  background: ${({ theme }) => theme.colors.neutral.black}90;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(4px);
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Header = styled.div`
  height: fit-content;
  width: 100%;

  padding: 32px;

  background-color: ${({ type, theme }) => Color({ type, theme })};
`;

const Color = ({ type, theme }) => {
  switch (type) {
    default:
    case "critical":
      return theme.colors.feedbackState.critical.default;
    case "success":
      return theme.colors.feedbackState.success.default;
  }
};
